
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media-coverage/[media]",
      function () {
        return require("private-next-pages/media-coverage/[media]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media-coverage/[media]"])
      });
    }
  